import {
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  UPDATE_EDIT_USER,
  START_EDIT_USER,
  CANCEL_EDIT_USER,
  UPDATE_USER_INFO_SUCCESS,
  GET_QUARANTINE_SUCCESS,
  SAVE_QUARANTINE_SUCCESS,
  DELETE_QUARANTINE_SUCCESS,
  ADD_CREDENTIAL_REQUEST,
  UPDATE_CREDENTIAL_REQUEST,
  ADD_CREDENTIAL_SUCCESS,
  ADD_CREDENTIAL_FAILURE,
  UPDATE_CREDENTIAL_FAILURE,
  PROBE_CREDENTIAL_SUCCESS,
  PROBE_CREDENTIAL_FAILURE,
  CLEAR_NEW_CRED_FOR_QUARANTINE,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = {
  currentValues: {},
  isEdit: false,
  quarantine: {
    id: null,
    newCredentialId: null,
    validCredential: null,
    error: null,
  },
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        error: null,
      };

    case GET_USERS_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case UPDATE_EDIT_USER:
      return {
        ...state,
        currentValues: {
          ...state.currentValues,
          [action.key]: action.value,
        },
      };

    case START_EDIT_USER:
      return {
        ...state,
        isEdit: true,
        currentValues: {},
      };

    case UPDATE_USER_INFO_SUCCESS:
    case CANCEL_EDIT_USER:
      return {
        ...state,
        isEdit: false,
        currentValues: {},
      };

    case GET_QUARANTINE_SUCCESS:
    case SAVE_QUARANTINE_SUCCESS:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          id: action.result,
        },
      };

    case DELETE_QUARANTINE_SUCCESS:
      return {
        ...state,
        quarantine: {
          id: null,
          newCredentialId: null,
          validCredential: null,
          error: null,
        },
      };

    case ADD_CREDENTIAL_REQUEST:
    case UPDATE_CREDENTIAL_REQUEST:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          error: null,
        },
      };

    case ADD_CREDENTIAL_SUCCESS:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          newCredentialId: action.result,
          validCredential: null,
          error: null,
        },
      };

    case PROBE_CREDENTIAL_SUCCESS:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          validCredential: true,
          error: null,
        },
      };

    case ADD_CREDENTIAL_FAILURE:
    case UPDATE_CREDENTIAL_FAILURE:
    case PROBE_CREDENTIAL_FAILURE:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          validCredential: false,
          error: action.message,
        },
      };

    case CLEAR_NEW_CRED_FOR_QUARANTINE:
      return {
        ...state,
        quarantine: {
          ...state.quarantine,
          newCredentialId: null,
          validCredential: null,
          error: null,
        },
      };

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};
